import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RetailerHomeRoutingModule } from './retailer-home-routing.module';
import { RetailerHomeComponent } from './retailer-home.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ControlsModule, FormFieldModule } from 'src/app/shared';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RetailerInternationalComponent } from './retailer-international/retailer-international.component';
import { RetailerDomesticComponent } from './retailer-domestic/retailer-domestic.component';
import { RetailerPridComponent } from './retailer-prid/retailer-prid.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    RetailerHomeComponent,
    RetailerInternationalComponent,
    RetailerDomesticComponent,
    RetailerPridComponent
  ],
  imports: [
    CommonModule,
    RetailerHomeRoutingModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    FormFieldModule,
    ControlsModule,
    NgbModule,
    ReusableModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule
  ]
})
export class RetailerHomeModule { }
